import { defineRecipe } from '@chakra-ui/react';

// Por algún motivo en base no funcionan los valores como borderColor, etc. por eso lo hacemos por variables. En Github, por ejemplo también
// para algunos casos lo hace con variables. ¿Cuáles si y cuáles no?, ni idea, no hay documentación sobre ello. En cambio en los variants ya funcionan
// los semanticTokens y las propiedades.

// Ejemplo de como en el input usan también las variables:
// https://github.com/chakra-ui/chakra-ui/blob/main/packages/react/src/theme/recipes/input.ts

export const inputRecipe = defineRecipe({
	base: {
		px: '4',
		fontSize: 'sm',
		fontWeight: 'medium',
		borderRadius: 'md',
		borderColor: { base: '{colors.neutral.300}', _dark: '{colors.neutral.600}' },
		bg: { base: 'white', _dark: '{colors.neutral.800}' },
		h: '10',
		_focusVisible: {
			focusRingColor: { base: '{colors.blue.500}', _dark: '{colors.blue.500}' },
			focusRingWidth: '0',
		},
		_invalid: {
			focusRingColor: 'error',
			borderColor: 'error'
		},
		'&.selected': {
			borderColor: '{colors.blue.500}',
			borderWidth: '1px',
		}
	},
	variants: {
		variant: {
			outline: {
				borderColor: { base: '{colors.neutral.300}', _dark: '{colors.neutral.600}' }
			},
		}
	}
});
